import { createAccessService } from './AccessService.impl';
import { myFeatureService } from '../FeatureService/FeatureService.connected';
import { myPermissionService } from '../PermissionService/PermissionService.connected';
import Account from 'lib/auth/Account';

export const myAccessService = createAccessService({
  services: {
    featureService: myFeatureService,
    permissionService: myPermissionService
  },
  getIsSuperUser: () => Account.isSuperUser()
});
